module.exports = __webpack_public_path__ + "static/media/th.5f831e47.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/th.svg
// module id = 958
// module chunks = 0